export interface LocationDescriptor<S> {
  pathname: string;
  state: S;
}

export const createStatefulLocationDescriptor = <S>(path: string, state: S): LocationDescriptor<S> => ({
  pathname: path,
  state,
});
